import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const SourceSortAscIcon = ({
  width = "21",
  height = "21",
  style,
  onClick,
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} style={style} onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={width}
        viewBox="0 0 24 24"
        style={{ transform: "rotate(270deg) !important" }}
      >
        <path
          fill="#1F293299"
          d="M8 18q-.825 0-1.412-.587T6 16V4q0-.825.588-1.412T8 2h12q.825 0 1.413.588T22 4v12q0 .825-.587 1.413T20 18zM8 6h12V4H8zM4 22q-.825 0-1.412-.587T2 20V6h2v14h14v2z"
        ></path>
      </svg>
    </IconWrapper>
  );
};
